<template>
  <div>
    <b-modal id="confirmation" title="Reset 2FA" centered>
      <slot />
      <template #modal-footer="{ ok, cancel }">
        <b-button variant="outline-secondary" @click="cancel()">
          Cancel
        </b-button>
        <b-button variant="secondary" @click="onOkClick(ok)">Reset</b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
export default {
  methods: {
    onOkClick(callback) {
      this.$emit("confirm");
      callback();
    },
  },
};
</script>
